/**
 * Empresa para la cual se muestra la pestaña "Adicional" (gerencia, superintendencia, área, motivo).
 * Por defecto "El Abra". Configurable vía REACT_APP_ADICIONAL_COMPANY_NAME.
 */
const ADICIONAL_COMPANY_NAME = (
  process.env.REACT_APP_ADICIONAL_COMPANY_NAME || 'El Abra'
).trim();

const ENAEX_COMPANY_NAME = (
  process.env.REACT_APP_ENAEX_COMPANY_NAME || 'ENAEX'
).trim();

/**
 * Indica si la pestaña/actualización Adicional debe mostrarse para la empresa dada.
 * Comparación por nombre normalizado (case-insensitive, sin espacios extra).
 */
export function isAdicionalEnabledForCompany(
  companyName: string | null | undefined
): boolean {
  if (!companyName) return false;
  const name = companyName.trim().toLowerCase();
  const allowed = ADICIONAL_COMPANY_NAME.toLowerCase();
  return allowed.length > 0 && name === allowed;
}

/** Empresa ENAEX: código en tabla propia y validaciones específicas. */
export function isEnaexCompany(companyName: string | null | undefined): boolean {
  if (!companyName) return false;
  const name = companyName.trim().toLowerCase();
  const allowed = ENAEX_COMPANY_NAME.toLowerCase();
  return allowed.length > 0 && name === allowed;
}

export default ADICIONAL_COMPANY_NAME;
